import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const physicalPrepaidCardStop = http.patch(
  createMockEndpoint('/physical_prepaid_card/:cardNumber/stop'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
